








































import settings from '@/settings'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import Menus from '@/components/menus'

export default {
    name: 'exports'

    components: { Menus }

    data: ()->
        start: ''
        end: ''
        alert: false
        picker_options: {firstDayOfWeek:1}
        name: {
            'medical_visit':'visites-medicales'
            'formation':'demandes-de-formations'
            'rup_rus':'rup-rus'
        }

    methods:
        get_file: (from)->
            # console.log "EXPORT DATES ", @start, @end
            # console.log "EXPORT DATES ", @start <= @end
            if @start <= @end
                self = @
                @$http.post(settings.exports, {"company_uid":@$store.getters.current_company.uid, "export_type":from, "start":@start, "end":@end})
                .then (resp)->
                    # console.log "EXPORT RESPONSE ", resp
                    if resp.status == 204
                        self.alert = true
                    else
                        start_array = self.start.split('-')
                        start = start_array[2]+'-'+start_array[1]+'-'+start_array[0]
                        end_array = self.end.split('-')
                        end = end_array[2]+'-'+end_array[1]+'-'+end_array[0]
                        file_name = "export_"+self.name[from]+"_"+start+"_"+end+".csv"
                        url = window.URL.createObjectURL(new Blob([resp.body]))
                        link = document.createElement('a')
                        link.href = url
                        link.setAttribute('download', file_name)
                        link.click()
            else
                n.warning('La date de fin doit être postérieure à la date de début')
            
    beforeMount: ()->
        start = new Date()
        @start = t.python_date_formatter(start).split(' ')[0]
        today = new Date()
        end = new Date(today.setMonth(today.getMonth()+1))
        @end = t.python_date_formatter(end).split(' ')[0]
}
